module.exports = __webpack_public_path__ + "static/media/re.93aac521.svg";